import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useQuestionsDeleteSpecific } from '../../api/hooks/Questions/useQuestionsDelete'
import { useVideosDeleteSpecific } from '../../api/hooks/Videos/useVideosDelete'
import styles from '../../styles/admin/List.module.scss'
import { LectureQuestionData } from '../../types/lectures'
import Label from '../common/Label'
import ClassListHeader from './ClassListHeader'
import ClassListItem from './ClassListItem'
import { Icon } from '../../assets/icons'
import { openConfirmModal } from '@mantine/modals'

interface ClassListComponentProps {
  data: LectureQuestionData[]
  currentPage: number
}

const ClassList = ({ data, currentPage }: ClassListComponentProps) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { deleteQuestion, isPending: isDeleting } = useQuestionsDeleteSpecific()
  const { deleteVideo, isPending: isDeletingVideo } = useVideosDeleteSpecific()

  const handleModifyClick = (item: LectureQuestionData) => {
    const isLecture = item.TYPE === 'VIDEO'

    console.log("data ? ,", data);

    if (isLecture) {
      navigate('/lectures/lecture/edit', {
        state: { videoId: item.QUESTION_ID, fromPage: currentPage, level:data[0].LEVEL },
      })
    } else {
      navigate('/lectures/quiz/edit', {
        state: { questionId: item.QUESTION_ID, fromPage: currentPage, level:data[0].LEVEL },
      })
    }
  }

  const handleDeleteClick = (item: LectureQuestionData) => {
    openConfirmModal({
      title: 'Are you sure you want to delete this?',
      children: (
        <div>
          <p>
            <strong>{item.DEPTH || item.TYPE}</strong>
          </p>
          <p>Are you sure you want to delete this?</p>
        </div>
      ),
      labels: { confirm: '삭제', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          if (item.QUESTION_ID === undefined) {
            alert('삭제할 항목의 QUESTION_ID가 없습니다.')
            return
          }

          if (item.TYPE === 'VIDEO') {
            await deleteVideo({ QUESTION_ID: Number(item.QUESTION_ID) })
          } else {
            await deleteQuestion({ QUESTION_ID: Number(item.QUESTION_ID) })
          }

          alert('삭제가 완료되었습니다.')

          await queryClient.invalidateQueries({
            queryKey: ['lectures', 'questions'],
          })
        } catch (error) {
          console.error('❌ Failed to delete.:', error)
          alert('An error occurred while deleting.')
        }
      },
    })
  }

  return (
    <div className={styles.listWrapper}>
      <ClassListHeader />

      {data && data.length > 0 ? (
        data.map((item, index) => (
          <ClassListItem
            key={`${item.QUESTION_ID}-${index}`}
            level={item.LEVEL || ''}
            mainChapter={item.MAIN.toString()}
            subChapter={item.SUB.toString()}
            unit={item.UNIT.toString()}
            detailUnit={item.DETAIL_UNIT.toString()}
            no={item.NO || 0}
            contentType={<Label text={item.TYPE || 'Class'} />}
            questionLabel={item.DEPTH || ''}
            modify={
              <div className={styles.modifyIcon}>
                <Icon
                  name="pen"
                  size={16}
                  onClick={() => handleModifyClick(item)}
                  color={'#b6bfca'}
                />
              </div>
            }
            deleteAction={
              <div className={styles.modifyIcon}>
                <Icon
                  name="trash"
                  size={20}
                  onClick={() => handleDeleteClick(item)}
                  color={'#b6bfca'}
                />
              </div>
            }
          />
        ))
      ) : (
        <div className={styles.empty}>
          <div className={styles.tableCell}>No Data Available.</div>
        </div>
      )}
    </div>
  )
}

export default ClassList
